import {FeatureFlag} from '../../../@type/features';
import {type IResponse} from '../../../@type/response';
import {Feature} from '../features';

async function createSetupIntent(paymentMethodType: string, paymentMethodId?: string): Promise<string | null> {
	const url = Feature.metadata<string>(FeatureFlag.STRIPE_GATEWAYS, 'setup_intent_url');
	const security = Feature.metadata<string>(FeatureFlag.STRIPE_GATEWAYS, 'setup_intent_nonce');

	if (!url || !security) {
		return null;
	}

	const formData = new FormData();
	formData.append('security', security);
	formData.append('payment_method_type', paymentMethodType);
	if (paymentMethodId) {
		formData.append('payment_method', paymentMethodId);
	}

	const response = await fetch(url, {
		method: 'POST',
		body: formData,
	});

	const data = await response.json() as IResponse<{setup_intent_details: {client_secret: string}}>;

	if (!data.success) {
		return null;
	}

	return data.data.setup_intent_details.client_secret;
}

export {createSetupIntent};
